module.exports = __webpack_public_path__ + "static/media/missile.f0faf674.ogg";